// extracted by css-extract-rspack-plugin
export default {"kicker":"kicker-L8_EMz","logo":"logo-_MbIcX"};